import { Typography, styled } from '@mui/material'
import type { SupportedLanguage } from '../../i18n'

const FallbackText = styled(Typography)({
  fontSize: '0.75rem',
})

const languageFlags: Record<SupportedLanguage, string> = {
  en: '🇬🇧',
  nl: '🇳🇱',
  cy: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
}

interface FlagEmojiProps {
  languageCode: SupportedLanguage
  size?: number
}

export const FlagEmoji = ({ languageCode, size = 24 }: FlagEmojiProps) => {
  const flag = languageFlags[languageCode]

  if (!flag) {
    return <FallbackText variant='caption'>{languageCode}</FallbackText>
  }

  return <Typography sx={{ fontSize: size, lineHeight: 1 }}>{flag}</Typography>
}
